import { module } from 'modujs';
const axios = require('axios').default;

export default class extends module {
    constructor(m) {
        super(m);

        if( this.$( 'turnstile' )[0] ){
            turnstile.render( this.$( 'turnstile' )[0] , { sitekey: '0x4AAAAAAAIbTBY67V5Xgbxu'});
        }

        this.el.addEventListener( 'submit', e => {
            e.preventDefault();
            this.el.classList.add( 'pointer-events-none');
            this.el.classList.add( 'loading');
            this.el.classList.remove( 'success' );
            this.el.classList.remove( 'failure' );

            this.call( 'update', false, 'Scroll');
            axios.post(THEME_OBJ.ajaxURL, new FormData( this.el ) ).then( (response) => {


                this.submitBtn = this.el.querySelector( 'button[type="submit"]').classList.remove( 'loading' );
                this.el.classList.remove( 'pointer-events-none');
                this.el.classList.remove( 'loading');

                if( response.data.success ){
                    this.el.classList.add( 'success' );
                    this.el.reset();
                    this.call( 'reset', false, 'Accompanies');
                } else {
                    this.el.classList.add( 'failure' );
                }
                this.call( 'update', false, 'Scroll');

            }).catch( (error) => {
                this.el.classList.remove( 'pointer-events-none');
                this.el.classList.remove( 'loading');
                this.el.classList.add( 'failure' );
            });

        });

    }
    init() {

    }
    destroy(){}
}
